import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { fetchUserByEmail } from 'services/api/suppliers';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddUserForEntityModal = props => {
  const {
    entityId,
    addUserAPI,
    onSuccess,
    toggleModal,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [userFound, setUserFound] = useState<boolean>(false);
  const [user, setUser] = useState<Record<string, any>>({});
  const [email, setEmail] = useState<string>('');

  const searchUser = async () => {
    setSearchLoading(true);
    try {
      const user = await fetchUserByEmail(email?.toLowerCase());
      setUserFound(true);
      setUser(user);
    } catch (e) {
      showError(e);
      setUser({});
      setUserFound(false);
    } finally {
      setSearchLoading(false);
    }
  };
  
  const addUserFn = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addUserAPI(user.objectId, entityId);
      await onSuccess();
      showSuccess('User added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const UserDetails = () => (
    <div className={styles['user-details']}>
      <div className={styles['user-name-section']}>
        <div className={styles['label']}>User Name</div>
        <div className={styles['user-name']}>{user.full_name}</div>
        <div className={styles['user-address']}>{user.address || ''}</div>
      </div>
      <div className={styles['user-phone-section']}>
        <div className={styles['label']}>Phone Number</div>
        <div className={styles['user-phone']}>{user.phone || 'N/A'}</div>
      </div>
    </div>
  );

  return (
    <form onSubmit={(e => e.preventDefault())} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>User</div>
            <div className={styles['modal-title']}>Add A New User</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>User Email</div>
            <div className={styles['email-input-container']}>
              <input
                className={'form-control'}
                onChange={e => setEmail(e.target.value)}
              />
              <ActionButton
                text={'Search'}
                isSubmit={true}
                active={!searchLoading}
                isLoading={searchLoading}
                onClick={searchUser}
              />
            </div>
          </div>
          {userFound && <UserDetails />}
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'button'}
            className={styles['submit-button']}
            disabled={loading || !userFound}
            onClick={addUserFn}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddUserForEntityModal;
